import React, { useEffect, useState } from "react"

export const usePaymentMethodSettings = (props)=>{
    const { paymentMethodsSettings } = props

    const [isPaymentEnabled, setIsPaymentEnabled] = useState(false)
    const [isQuoteEnabled, setIsQuoteEnabled] = useState(false)
    const [quoteSettings, setQuoteSettings] = useState(null)
    const [mainSettings, setMainSettings] = useState(null);
    const [checkConvenienceFee, setCheckConvenienceFee] = useState(false)
    const creditCardPayments = ['cardconnectSettings']

    useEffect(()=>{
        let flag = false
        let flagQuote = false
        if ( paymentMethodsSettings && paymentMethodsSettings.length > 0 ) {
            setQuoteSettings(paymentMethodsSettings.filter(item => item.settingsName === 'quoteSettings')[0]?.values[0])
            paymentMethodsSettings.map((methodData)=>{
                if (
                    methodData.settingsName &&
                    methodData.settingsName !== 'paymethodSettings'
                ) {
                    if ( methodData.values && methodData.values.length > 0 ) {
                        if ( methodData.values[0] ) {
                            if ( methodData.values[0].isEnabled ) {
                                flag = true
                                if(creditCardPayments.findIndex(x => x === methodData.settingsName && methodData?.values?.[0]?.convenienceFee) > -1) {
                                    setCheckConvenienceFee(true);
                                }
                            }
                            if(methodData.values[0].showQuoteButton) {
                                flagQuote = true
                            }
                        }
                    }
                } else {
                    if(methodData?.values?.[0]) {
                        setMainSettings(methodData.values[0])
                    }
                }
            })
        }
        if ( flag ) {
            setIsPaymentEnabled(true)
        }
        setIsQuoteEnabled(flagQuote)
    }, [paymentMethodsSettings])

    const getSettingArrayByName = (name) => {
        let tempData = null
        paymentMethodsSettings &&
        paymentMethodsSettings.map((methodData) => {
            if (methodData.settingsName && methodData.settingsName == name) {
                if (methodData.values && methodData.values.length > 0) {
                    if (methodData.values[0]) {
                        tempData = methodData.values[0]
                    }
                }
            }
        })
        return tempData
    }

    return {
        getSettingArrayByName,
        isPaymentEnabled,
        isQuoteEnabled,
        quoteSettings,
        mainSettings,
        checkConvenienceFee,
    }
}
